// src/graphql/mutations/subscriptionMutations.js

export const createSubscription = `mutation CreateSubscription($input: CreateSubscriptionInput!) {
    createSubscription(input: $input) {
        success
        message
        subscription {
            id
            tier
            status
            companyId
        }
        error
    }
}`;

export const updateSubscription = `mutation UpdateSubscription($id: String!, $input: UpdateSubscriptionInput!) {
    updateSubscription(id: $id, input: $input) {
        success
        message
        subscription {
            id
            tier
            status
        }
        error
    }
}`;

export const cancelSubscription = `mutation CancelSubscription($id: String!, $force: Boolean) {
    cancelSubscription(id: $id, force: $force) {
        success
        message
        error
    }
}`;
